export function findLinkedProjectId(sections) {
  for (const section of sections || []) {
    let content = section.content;
    if (typeof content === 'string') { try { content = JSON.parse(content); } catch { continue; } }
    for (const block of content?.blocks || []) {
      if (block.type === 'SubsectionBuilderBlock' && block.data?.linkedProjectId)
        return block.data.linkedProjectId;
      // v2 kuntoarviovalikko stores its chosen PTS-projekti at data.ptsProjectId
      // (see julkisivuV2/services/useKuntoarviovalikkoV2.js), not data.linkedProjectId —
      // same cross-block sync contract, different storage shape.
      if (block.type === 'KuntoarviovalikkoBlockV2' && block.data?.ptsProjectId)
        return block.data.ptsProjectId;
    }
  }
  return null;
}
